import React, { useState, useEffect } from 'react'
import { Combo } from 'components'
import { fetchUrl } from 'modules/util/functions'

const CarcasaCombo = (props) => {
	const [items, setItems] = useState([]);

	useEffect(() => {
		fetchUrl("/query/getCarcasas", "get", {}, {
			success: (r) => {
				let items = r.data.carcasas.map(x => ({
					value: x.idCarcasa,
					label: x.nombre
				}));

				if (props.exclusions)
					items = items.filter(x => !props.exclusions.includes(x.value.toString()));

				setItems(items);
			}
		}, { block: false });
	}, [props.exclusions]);

	return (
		<Combo
			{...props}
			items={items} />
	)
}

export default CarcasaCombo;

CarcasaCombo.defaultProps = {
	formControl: true,
	formManaged: false
};